export const GET_ADD_FUNDS_LIMITS_URL = '/api/v1/user/add-funds'
